import { Typography } from '@atlas-metrics/design-system';
import React from 'react';

import Tooltip from '../ui/Tooltip';

import { ProgressChartDisclosureResult } from '@/types';

type Props = {
  data: ProgressChartDisclosureResult[] | undefined;
  onMouseOver?: (i: number) => void;
  onMouseOut?: () => void;
  activeIndex?: number | null;
};

export const ProgressChart: React.FC<Props> = ({
  data,
  onMouseOver,
  onMouseOut,
  activeIndex = null,
}) => {
  const totalPercentage =
    data?.reduce((sum, item) => sum + item.percentage, 0) || 0;
  const missingPercentage = 100 - totalPercentage;

  const bars = data?.map((d, index) => (
    <Tooltip text={`${d.percentage}`} key={index}>
      <div
        onMouseOver={() => onMouseOver && onMouseOver(index)}
        onMouseOut={onMouseOut}
        className='flex flex-grow cursor-pointer items-center justify-between rounded-3xl'
        // when adding colour dynamically in className, e.g. bg-[${d.color}], it doesn't get applied by tailwind
        style={{
          background:
            activeIndex === index || activeIndex === null ? d.color : '#E5E4E4',
          width: `${d.percentage}%`,
        }}
      />
    </Tooltip>
  ));

  return (
    <div className='mx-4 my-6'>
      <div className='my-4 flex justify-between font-regular text-ds-grey-700'>
        <Typography variant='body-m'>0%</Typography>
        <Typography variant='body-m'>100%</Typography>
      </div>
      <div className='flex h-3 justify-center gap-1'>
        {bars}
        {missingPercentage > 0 && (
          <div
            className='flex flex-grow items-center justify-between rounded-3xl bg-[#E5E4E4]'
            style={{
              width: `${missingPercentage}%`,
            }}
          />
        )}
      </div>
    </div>
  );
};
